/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/space-before-function-paren */
import { isFalsy } from '../../common';
/**
 *@param this Validates the grade entered by the user based on the grade system selected.
 *@this any
 *@returns boolean or throws an error if the grade is invalid.
 */
function validGradeCheck(gradeKey, gradeSystemKey, allowNullable) {
    return this.test('validGradeCheck', '', function (value) {
        var _a, _b, _c, _d, _e;
        try {
            var gradeSystem = gradeSystemKey ? (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a[gradeSystemKey]) === null || _b === void 0 ? void 0 : _b.value : (_d = (_c = this.parent) === null || _c === void 0 ? void 0 : _c.gradeSystem) === null || _d === void 0 ? void 0 : _d.value;
            if (!gradeSystem)
                return true;
            var grade = (_e = this.parent) === null || _e === void 0 ? void 0 : _e[gradeKey];
            var isGradeNullable = isFalsy(grade);
            if (gradeSystem === 'CGPA') {
                var validGrade = Number(grade) >= 0 && Number(grade) <= 10;
                if (!(allowNullable && isGradeNullable) && !validGrade) {
                    return this.createError({
                        message: 'Enter grade between 0 and 10'
                    });
                }
            }
            else if (gradeSystem === 'PERCENTAGE') {
                var validGrade = Number(grade) >= 0 && Number(grade) <= 100;
                if (!(allowNullable && isGradeNullable) && !validGrade) {
                    return this.createError({
                        message: 'Enter percentage between 0 and 100'
                    });
                }
            }
            else if (gradeSystem === 'ZERO_TO_FOUR') {
                var validGrade = Number(grade) >= 0 && Number(grade) <= 4;
                if (!(allowNullable && isGradeNullable) && !validGrade) {
                    return this.createError({
                        message: 'Enter grade between 0 and 4'
                    });
                }
            }
            return true;
        }
        catch (error) {
            console.log(error);
            return true;
        }
    });
}
export { validGradeCheck };
//# sourceMappingURL=string.methods.js.map